
/**
 * 태그로 필터링 (선택 사항)
 */
export type TagParamParameter = string;
